module.exports = __webpack_public_path__ + "static/media/profile.f275abad.svg";